// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"343":"07ac35ae","987":"5790c2a4"}[chunkId] + ".chunk.js";
};